<template>
  <b-card no-body>
    <b-card-header class="align-items-baseline">
      <div class="w-100">
        <b-card-title>
          <slot name="title"></slot>
        </b-card-title>
        <!-- <b-card-text class="mb-0"> Last 6 months </b-card-text> -->
      </div>
    </b-card-header>
    <b-card-body>
      <vue-apex-charts
        v-if="isRenderingChart"
        type="donut"
        height="400"
        :options="chartOptions"
        :series="chartOptions.series"
      />
    </b-card-body>
  </b-card>
</template>
<script>
export default {
  props: {
    getChartData: {
      type: Function,
      required: true,
    },
  },
  mounted() {
    let _this = this;
    this.getChartData(_this);
  },
  data() {
    return {
      chartOptions: {
        chart: {
          fontFamily: "IranSans",
        },
        series: [],
        colors: [
          "#a50000",
          "#005f96",
          "#00a53f",
          "#000000",
          "#5c0064",
          "#fa1db8ee",
        ],
        dataLabels: {
          position: "top",
          enabled: true,
          style: {
            fontFamily: "IranSans",
            fontWeight: "normal",
          },
        },
        tooltip: {
          style: {
            fontWeight: "normal",
          },
        },

        legend: {
          position: "top",
          horizontalAlign: "center",
          fontFamily: "IranSans",
          fontWeight: "normal",
          markers: {
            width: 12,
            height: 12,
            strokeWidth: 0,
            strokeColor: "#fff",
            fillColors: undefined,
            radius: 12,
            offsetX: "5px",
          },
        },
      },
      chartPayload: {
        pageNumber: 1,
        count: 50,
      },
      isRenderingChart: false,
    };
  },
  methods: {
    renderChart() {
      this.isRenderingChart = true;
    },
  },
  components: {
    VueApexCharts,
    BDropdown,
    BDropdownItem,
    BCardText,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
  },
};
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BCardBody,
  BCardText,
  BDropdown,
  BDropdownItem,
} from "bootstrap-vue";
import VueApexCharts from "vue-apexcharts";
</script>
